import { CartResponse } from 'common/api/e-comm/cart/lineitem/models/CartItems';
import { sumBy } from 'common/utils';
import { MAX_SHIP_TO_HOME_CARD_QUANTITY } from 'config';

export const isOrderExceedsMaxCards = (cart: CartResponse) => {
    const shipToHomeItems = cart.lineItems.filter((item) => item.product.isShipToHomeEligible);
    const shipToHomeQuantity = sumBy(shipToHomeItems, (item) => item.quantity);
    return shipToHomeQuantity > MAX_SHIP_TO_HOME_CARD_QUANTITY;
};
